import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSessionService } from './session/app-session.service';
import { AuthService } from './auth/auth.service';
import { AppUrlService } from './nav/app-url.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { IonicStorageModule } from '@ionic/storage';
import { AppStorageService } from './storage/app-storage.service';
import { PermissionCheckerService } from './auth/permission-checker.service';
import { FeatureCheckerService } from './multi-tenancy/feature-checker.service';
import { NotifyService } from './notify/notify.service';
import { SettingService } from './settings/settings.service';
import { MessageService } from './message/message.service';
import { MultiTenancyService } from './multi-tenancy/mult-tenancy.service';
import { LogService } from './log/log.service';
import { AppHttpConfiguration, AppHttpInterceptor } from './app-http-interceptor';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        IonicStorageModule.forRoot()
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AuthService,
                AppRouteGuard,
                AppStorageService,
                PermissionCheckerService,
                FeatureCheckerService,
                NotifyService,
                SettingService,
                MessageService,
                MultiTenancyService, 
                LogService,
                AppHttpInterceptor,
                AppHttpConfiguration
            ]
        };
    }
}
